import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { StyleSheet } from 'react-native';
import { theme } from '@xbto/design-system';
import { Button, Col, Row, TextBody, TextTitle, } from '../../atoms';
import { BadgeIcon } from '../badge-icon';
export const Callout = memo(({ children, contained = false, icon, message, small = false, large = false, title, variant = 'brand', ctas, }) => {
    const isDefaultSize = !small && !large;
    const titleEl = isDefaultSize || large ? (_jsx(TextTitle, { center: true, large: true, children: title })) : (_jsx(TextBody, { center: true, em: true, lhFull: true, children: title }));
    return (_jsxs(Col.C, { style: [$.container, contained && $.contained], children: [!!icon && (_jsx(Col, { mb: "8", children: _jsx(BadgeIcon, { small: small, variant: variant, name: icon }) })), titleEl, _jsx(TextBody, { mt: small ? '3' : large ? '2' : '6', large: large, center: true, children: message }), !!children && _jsx(Col, { mt: "6", children: children }), !!(ctas === null || ctas === void 0 ? void 0 : ctas.length) && (_jsx(Row.LR, { mt: large ? '6' : '8', style: [$.ctas, ctas.length === 1 && $.singleCta], children: ctas.map((props, index) => (_jsx(Button, Object.assign({}, props, { fullWidth: true }), index))) }))] }));
});
const $ = StyleSheet.create({
    container: {
        flex: 1,
        paddingVertical: theme.spacing['6'],
        paddingHorizontal: theme.spacing['4'],
    },
    contained: {
        backgroundColor: theme.color.background.tertiary,
        borderWidth: 1,
        borderColor: theme.color.border.primary,
        borderRadius: theme.radius.md,
    },
    ctas: {
        columnGap: theme.spacing['3'],
        width: '100%',
    },
    singleCta: {
        width: 'auto',
    },
});
